import { Injectable } from '@angular/core';
import { API_METHODS, API_URL } from 'common/constants/sm-constants';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';

import { environment } from 'src/environments/environment';
import { CreditModel } from 'common/models/page-models/credits/credit-data-model';
import { FormDataService } from '../../base-data-services/form-data.service';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class CreditFormDataService extends FormDataService<CreditModel> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.addCreditMaster, http, ss);
  }

  override getEditUrlAndMethod(id) {
    const edit = {
      url: environment.apiUrl + API_URL.getCreditMasterDataById,
      method: API_METHODS.post,
    };
    return edit;
  }

  override getUpdatePayload(data) {
    let payload;
    payload = {
      id: data.id,
    };
    return payload;
  }

  createInstance(): CreditModel {
    return new CreditModel();
  }

  override beforePostData(
    model: any,
    metamodel: any,
    dataModel: any
  ): Promise<CreditModel> {
    return new Promise<any>((resolve, reject) => {
      // console.log(model, 'model');
      model.yearSelected = moment(model.yearSelected).format('YYYY');
      model.credits = Number(model.credits)
      resolve(model);
    });
  }

  override getUpdateUrl() {
    return API_URL.editCreditMaster;
  }

  override modifyPostModel(formModel: any, dataModel: any) {
    formModel['creditMasterId'] = dataModel.id;
    return formModel;
  }
}
